import { activeTool, spaceDown, type ToolId } from '../editor.ts'
import { panTool } from './pan.ts'
import { penTool } from './pen.ts'
import { selectTool } from './select.ts'
import { chainTool } from './chain.ts'
import { makeShapeTool } from './shapes.ts'
import { textTool } from './text.ts'
import type { Tool } from './types.ts'

const tools: Record<ToolId, Tool> = {
  select: selectTool,
  pan: panTool,
  rect: makeShapeTool('rect'),
  ellipse: makeShapeTool('ellipse'),
  line: chainTool,
  pen: penTool,
  text: textTool,
}

export function currentTool(): Tool {
  return tools[activeTool()]
}

export function currentCursor(): string {
  if (spaceDown()) return 'grabbing'
  return currentTool().cursor
}

export const TOOL_KEYS: Record<string, ToolId> = {
  v: 'select',
  h: 'pan',
  r: 'rect',
  o: 'ellipse',
  l: 'line',
  p: 'pen',
  t: 'text',
}
